import { call, put, takeLatest } from 'redux-saga/effects';

import * as couponActions from './couponActions.js';
import { updateCouponApiCall } from './couponAPI.js';

function* updateCouponSaga({ payload }) {
  try {
    const { data } = yield call(updateCouponApiCall, payload);
    yield put(couponActions.couponUpdateStore(data));
  } catch (error) {
    yield put(couponActions.couponUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* couponWatcher() {
  yield takeLatest(couponActions.couponUpdateRequest.type, updateCouponSaga);
}
